import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function ProductSections({ product }) {
  const sections = product.sections || [];
  if (!sections.length && !product.important_note) return null;
  const accent = product.accent || '#4DA3FF';
  return (
    <div className="grid md:grid-cols-2 gap-5 max-w-5xl" data-testid="product-sections">
      {sections.map((s) => (
        <div key={s.title} className="glass rounded-2xl p-6" data-testid={`product-section-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
          <p className="text-xs uppercase tracking-[0.35em] font-mono mb-4" style={{ color: accent }}>{s.title}</p>
          {s.intro && <p className="text-sm text-white/60 mb-4">{s.intro}</p>}
          {(s.groups || []).map((g) => (
            <div key={g.label} className="mb-4 last:mb-0">
              <div className="text-[11px] uppercase tracking-widest text-white/40 mb-2">{g.label}</div>
              <div className="flex flex-wrap gap-2">
                {g.items.map((it) => (
                  <span key={it} className="px-3 py-1 rounded-md text-sm text-white/90 bg-white/[0.04] border border-white/10">{it}</span>
                ))}
              </div>
            </div>
          ))}
          {s.rows && (
            <dl className="space-y-2.5 text-sm">
              {s.rows.map(([k, v]) => (
                <div key={k} className="grid grid-cols-3 gap-3">
                  <dt className="text-white/40">{k}</dt>
                  <dd className="col-span-2 text-white/85">{v}</dd>
                </div>
              ))}
            </dl>
          )}
        </div>
      ))}
      {product.important_note && (
        <div data-testid="product-important-note" className="md:col-span-2 flex gap-3 rounded-2xl p-5 border border-amber-400/30 bg-amber-400/[0.06] text-sm text-amber-100/90">
          <AlertTriangle className="h-5 w-5 text-amber-300 shrink-0 mt-0.5" />
          <p><span className="font-semibold text-amber-300">Important:</span> {product.important_note}</p>
        </div>
      )}
    </div>
  );
}
